import DesignPlanningMarquee from "./DesignPlanningMarquee";
import { DynamicMarquee } from "./DynamicMarquee";

const skills = [
  {
    name: "Adobe Photoshop",
    username: "@photoshop",
    category: "Design",
    body: "Used extensively during the era of HTML slicing. Photoshop was my go-to tool for creating web-ready media and layouts.",
    img: "./adobe_photoshop.jpg",
  },
  {
    name: "DrawIO",
    username: "@drawio",
    category: "Planning",
    body: "A free and user-friendly tool for everything from planning app workflows to setting up VPC architectures.",
    img: "./drawio.jpg",
  },
  {
    name: "Adobe Animate",
    username: "@animate",
    category: "Design",
    body: "Started with Macromedia Flash, then transitioned to Animate. It enables canvas-based animations and JavaScript integration for the web.",
    img: "./adobe_animate.jpg",
  },
  {
    name: "After Effects",
    username: "@aftereffects",
    category: "Design",
    body: "Basic knowledge of animations and transitions for producing motion graphics and video effects.",
    img: "./adobe_iafter_effects.jpg",
  },
  {
    name: "Adobe Illustrator",
    username: "@illustrator",
    category: "Design",
    body: "My primary tool for creating vector-based assets and illustrations used across various digital media.",
    img: "./adobe_illustrator.jpg",
  },
  {
    name: "Adobe InDesign",
    username: "@indesign",
    category: "Design",
    body: "Ideal for layout and print materials. I’ve used it to design and export polished CVs and documents.",
    img: "./adobe_indesign.jpg",
  },
  {
    name: "Postman",
    username: "@postman",
    category: "Planning",
    body: "Essential for API testing and previewing, making collaboration with fellow developers much smoother.",
    img: "./postman.jpg",
  },
  {
    name: "Adobe Premiere Pro",
    username: "@premiere",
    category: "Design",
    body: "My choice for editing gaming videos. Offers features like scaling, transitions, blurring, and FPS overlays.",
    img: "./adobe_premiere_pro.jpg",
  },
  {
    name: "Adobe XD",
    username: "@xd",
    category: "Design",
    body: "Often used for UI/UX prototyping. Designers share screens and flows for mobile and web development.",
    img: "./adobe_xd.jpg",
  },

  {
    name: "Litmus",
    username: "@litmus",
    category: "Planning",
    body: "A must-have for email marketing design. Helps ensure content renders correctly across different email clients.",
    img: "./litmus.jpg",
  },
  {
    name: "Figma",
    username: "@figma",
    category: "Design",
    body: "Figma is one of the most popular collaborative UI/UX design tools today. I use it to explore layouts and handoff designs efficiently.",
    img: "./figma.svg",
  },
];

const firstRow = skills.slice(0, skills.length / 2);
const secondRow = skills.slice(skills.length / 2);

export function DesignMarqueeContent() {
  return (
    <div className="relative flex h-[300px] flex-row items-center justify-center overflow-hidden">
      <DynamicMarquee
        items={firstRow}
        renderItem={(skill) => (
          <DesignPlanningMarquee key={skill.username} {...skill} />
        )}
        duration="20s"
      />
      <DynamicMarquee
        items={secondRow}
        renderItem={(skill) => (
          <DesignPlanningMarquee key={skill.username} {...skill} />
        )}
        reverse
        duration="20s"
      />
      <div className="pointer-events-none absolute inset-x-0 top-0 h-1/4 bg-gradient-to-b from-background"></div>
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/4 bg-gradient-to-t from-background"></div>
    </div>
  );
}
